module.exports = __webpack_public_path__ + "715466db0b320a77af82839f5ebdc7d5.svg";


//////////////////
// WEBPACK FOOTER
// ./components/icon/svg/exclamation.svg
// module id = LpZc
// module chunks = 0